// O nhap tien (MoneyInput): tu chuoi trong o sau mot lan go, tinh ra chu so va so chu so nam ben trai con tro,
// khong phu thuoc React (unit test bang node). Con tro duoc dat lai sau dung ngan ay chu so trong chuoi da
// dinh dang, nen go, sua giua, xoa, dan deu giu dung thu tu (khach 2026-10-03: 2.223.000 thanh 22.230.000).
export type KetQua = { digits: string; left: number };

// raw: chuoi trong o, caret: vi tri con tro trong raw, prev: chu so truoc lan go, inputType: InputEvent.inputType
export function chuanHoa(raw: string, caret: number, prev: string, inputType: string, maxDigits: number): KetQua {
  let digits = raw.replace(/\D/g, '');
  let left = raw.slice(0, caret).replace(/\D/g, '').length;
  // phim xoa chi xoa trung dau cham (chu so khong doi): xoa chu so ke ben, dung y nguoi go
  if (digits === prev && raw.length > 0) {
    if (inputType === 'deleteContentBackward' && left > 0) { digits = digits.slice(0, left - 1) + digits.slice(left); left -= 1; }
    else if (inputType === 'deleteContentForward' && left < digits.length) digits = digits.slice(0, left) + digits.slice(left + 1);
  }
  // bo so 0 o dau, giu lai mot so 0 don (luat cua cac o so cu)
  const z = /^0+(?=\d)/.exec(digits)?.[0].length ?? 0;
  digits = digits.slice(z);
  left = Math.max(0, left - z);
  // qua so chu so toi da: tu choi ca lan go (khong cat bot am tham), con tro ve cho cu
  if (digits.length > maxDigits) return { digits: prev, left: Math.min(prev.length, Math.max(0, left - (digits.length - prev.length))) };
  return { digits, left: Math.min(left, digits.length) };
}

// vi tri trong chuoi da dinh dang ngay sau chu so thu `left`
export function viTri(display: string, left: number): number {
  if (left <= 0) return 0;
  let n = 0;
  for (let i = 0; i < display.length; i++) {
    if (display[i]! >= '0' && display[i]! <= '9' && ++n === left) return i + 1;
  }
  return display.length;
}
